<script>

///Ultima alteração: 07/12/2020
///Alterado por: Allinne
///Ajuste mobile quando não há fotos


    import { fade, fly }                    from 'svelte/transition';
	import { quintOut }                     from 'svelte/easing';
	import { createEventDispatcher }		from 'svelte';
		
    export let gallery          = null;
    export let galleryHeight    = "70vh";
    export let galleryPhotos    = 5;

	galleryPhotos 	=  gallery.length >= galleryPhotos ? galleryPhotos : gallery.length;

	const dispatch 	= createEventDispatcher();

    function viewPhoto(pos, photo) {
        dispatch('viewPhoto', {
			pos: pos,
			photo: photo
		});		
	}
</script>

{#if gallery != null}
	<div class="galeria-hero galeria-hero--showcase">
		<ul class="photos photos--{galleryPhotos}" style="height: {galleryHeight}">
			{#if gallery.length > 0}
				{#each gallery as photo, i}
					{#if i <= galleryPhotos - 1}
						<li class="photo photo--{i + 1}" on:click={() => viewPhoto(i, photo)}>
							<img class="img-loading" onerror="ImageNotFound(this);" src="{photo.Path}" alt="{photo.Title}"/>
						</li>
					{/if}		
				{/each}
			{:else}
				<li class="photo photo--0">
					<img onerror="ImageNotFound(this);" src="ImageNotFound" alt="Foto não encontrada"/>
				</li>			
			{/if}
		</ul>
		<div class="overlay">
			<div class="container">
				<div class="docks">
					<div class="dock left">
						<slot name="dock-left"></slot>
					</div>
					<div class="dock right">
						<slot name="dock-right"></slot>
					</div>
				</div>
			</div>
		</div>
	</div>
{/if}

<style type="text/sass">
@import 'public/assets/sass/variables.sass'

.galeria-hero
	&.galeria-hero--showcase
		position: relative
		.photos
			display: grid 
			&:hover 
				.photo img 
					opacity: 0.6
			&.photos--1
				grid-template: "photo--1"
			&.photos--2
				grid-template: "photo--1 photo--2"
			&.photos--3
				grid-template: "photo--1 photo--2" 50% "photo--1 photo--3" 50%
			&.photos--4
				grid-template: "photo--1 photo--1 photo--2 photo--3" 50% "photo--1 photo--1 photo--4 photo--4" 50%
			&.photos--5
				grid-template: "photo--1 photo--1 photo--2 photo--3" 50% "photo--1 photo--1 photo--4 photo--5" 50%
			+media-breakpoint-down(sm)
				.photo 
					display: none 
					&.photo--0
						display: block
					&.photo--1
						display: block
			.photo 
				cursor: pointer
				overflow: hidden
				background-color: #000
				border: 1px solid #000
				&.photo--1
					grid-area: photo--1
				&.photo--2
					grid-area: photo--2
				&.photo--3
					grid-area: photo--3
				&.photo--4
					grid-area: photo--4
				&.photo--5
					grid-area: photo--5
				img
					+transition(450ms cubic-bezier(0.645, 0.045, 0.355, 1) 0s)
					height: 100%
					width: 100%
					object-fit: cover
					&:hover
						overflow: hidden
						transform: scale(1.3)
						opacity: 1
		.overlay
			position: absolute
			bottom: 0px
			background-color: rgba(0,0,0,0.6)
			width: 100%
			padding: 15px 10px
			font-size: $font-title
			.docks 
				display: flex
				flex-wrap: wrap 
				align-items: center
				justify-content: space-between
			a
				color: #fff
				&:visited, &:hover
					color: #fff
</style>